import styled from "styled-components";
import CardHeader from "./CardHeader";
import useStudentCounsel from "features/teacher/hooks/student/useStudentCounsel";
import { useNavigate } from "react-router-dom";
import { hw, scrollbar } from "features/homework/homeworkUi";

interface StudentCounselProps {
    student_uid: string;
}

const StudentCounsel = ({ student_uid }: StudentCounselProps) => {
    const { counsel } = useStudentCounsel(student_uid);
    const navigate = useNavigate();
    return (
        <Container>
            <CardHeader title="상담" onNextClick={() => { navigate("/teacher/student/profile/counsel", { state: student_uid }); }} />
            <DateLine>상담일 {counsel.counsel_date || "-"}</DateLine>
            <Block>
                <BlockHead>상담내용</BlockHead>
                <BlockBody>{counsel.counsel_detail || "최근 상담 내용이 없습니다."}</BlockBody>
            </Block>
            <Block>
                <BlockHead>조치내용</BlockHead>
                <BlockBody>{counsel.action_detail || "조치 내용이 없습니다."}</BlockBody>
            </Block>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
    min-height: 0;
    padding: 18px 20px;
    border-radius: 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    box-shadow: ${hw.shadow};
`;

const DateLine = styled.div`
    color: ${hw.textMuted};
    font-size: 13px;
    font-weight: 600;
`;

const Block = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    border-radius: 12px;
    border: 1px solid ${hw.brandMuted};
    background: ${hw.brandSoft};
`;

const BlockHead = styled.div`
    padding: 10px 14px;
    background: ${hw.brandMuted};
    color: ${hw.text};
    font-size: 13px;
    font-weight: 700;
`;

const BlockBody = styled.div`
    flex: 1;
    min-height: 80px;
    padding: 12px 14px;
    color: ${hw.text};
    font-size: 14px;
    line-height: 1.55;
    overflow: auto;
    ${scrollbar}
`;

export default StudentCounsel;
